/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_MapInputs */

const cs_property_list_map = /** @type {(inputs: Property_List_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit na mapě`)
};

const en_property_list_map = /** @type {(inputs: Property_List_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show on map`)
};

/**
* | output |
* | --- |
* | "Show on map" |
*
* @param {Property_List_MapInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_map = /** @type {((inputs?: Property_List_MapInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_MapInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_map(inputs)
	return cs_property_list_map(inputs)
});